import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Company } from '@typeRoots/common/company';
import { initialCompanyState } from './initialState';

interface CompanyState {
  company: Company | null;
  isDirty: boolean; // Tracks unsaved changes
}

const initialState: CompanyState = {
  company: initialCompanyState,
  isDirty: false,
};

export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompany(state, action: PayloadAction<Company>) {
      state.company = {
        ...state.company,
        ...action.payload,
      };
      state.isDirty = false; // Data is loaded from backend, no unsaved changes
    },
    updateCompany(state, action: PayloadAction<Partial<Company>>) {
      if (state.company) {
        // Check if the payload introduces any changes
        const hasChanges = Object.entries(action.payload).some(
          ([key, value]) => state.company![key as keyof Company] !== value,
        );
        if (hasChanges) {
          state.company = {
            ...state.company,
            ...action.payload,
          };
          state.isDirty = true; // Mark as dirty if there are changes
        }
      }
    },
    saveCompany(state) {
      state.isDirty = false; // Data is now saved
    },
    clearCompany(state) {
      state.company = initialCompanyState;
      state.isDirty = false;
    },
    resetDirtyFlag(state) {
      state.isDirty = false; // Explicitly reset the dirty flag
    },
  },
});

export const { setCompany, updateCompany, saveCompany, clearCompany, resetDirtyFlag } =
  companySlice.actions;

export default companySlice.reducer;
